import { render, staticRenderFns } from "./PerformancePersonConfigList.vue?vue&type=template&id=7f3ab3cb&scoped=true&"
import script from "./PerformancePersonConfigList.vue?vue&type=script&lang=js&"
export * from "./PerformancePersonConfigList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f3ab3cb",
  null
  
)

export default component.exports